import Box from "@mui/material/Box";
import { CardBrand, PaymentMethodData } from "../../types/payment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { BrandIcon } from "./BrandIcon";

type SuccessReceiptProps = {
  orderId: string;
  paymentMethodData: PaymentMethodData;
  amount: string;
  transactionId: string;
  date?: string;
};

export const SuccessReceipt = ({
  orderId,
  paymentMethodData,
  amount,
  transactionId,
  date,
}: SuccessReceiptProps) => {
  const brand: CardBrand = paymentMethodData?.brand || "unknown";
  if (!paymentMethodData) {
    return null;
  }

  return (
    <Box sx={{ textAlign: "center", py: 2 }}>
      <CheckCircleIcon sx={{ fontSize: 64, color: "success.main", mb: 2 }} />
      <Typography
        variant="h5"
        fontWeight={600}
        color="success.main"
        gutterBottom
      >
        Payment Successful!
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Your payment has been processed successfully
      </Typography>
      <Paper
        elevation={0}
        sx={{ p: 3, backgroundColor: "grey.50", borderRadius: 2, mb: 3 }}
      >
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Payment Receipt
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Amount
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {Number(amount).toLocaleString()}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Payment Method
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <BrandIcon brand={brand} />
              <Typography variant="body1" fontWeight={600}>
                {!paymentMethodData.laoQr && paymentMethodData.last4 ? (
                  <>•••• {paymentMethodData.last4}</>
                ) : (
                  <>Lao QR</>
                )}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Transaction ID
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {transactionId}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Order ID
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {orderId}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Date & Time
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {date || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
        <Button variant="contained" onClick={() => window.print()}>
          Print Receipt
        </Button>
      </Box>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 3, display: "block" }}
      >
        Keep this receipt for your records. A confirmation email has been sent
        to you.
      </Typography>
    </Box>
  );
};
